import { useParams } from "react-router";

export function useRequiredParam<T extends string>(key: T): string {
  const params = useParams<Record<T, string>>();
  const value = params[key as keyof typeof params] as string | undefined;
  if (!value) {
    throw new Error(`Missing required route param: ${key}`);
  }
  return value;
}
